import Button from '@/features/shared/Button';
import Image from '@/features/shared/Image';
import { MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import { ChevronRight } from '@material-ui/icons';
import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { SquareTileColumnContent, SquareTileSmallContent } from '../SquareTileCTA.interface';
import useStyles from './SmallCTA.styles';

const WithLink = ({
  link,
  children,
  className,
}: PropsWithChildren<{ link?: string; className?: any }>) => {
  return link ? (
    <Button
      variant="link"
      link={{
        href: link,
      }}
      className={className}
      data-testid="qa-small-cta-component-link"
    >
      {children}
    </Button>
  ) : (
    <div className={className}>{children}</div>
  );
};

const SmallCTA = ({ theme = Theme.light, content }: Partial<SquareTileSmallContent>) => {
  const classes = useStyles({ numOfCTAs: 0 });

  const rootClasses = clsx(classes.root, `${theme}-theme`);
  return (
    <WithLink link={content?.link} className={rootClasses}>
      <div data-testid="qa-small-cta-component">
        {content?.image ? (
          <div className={classes.img} data-testid="qa-small-cta-component-image">
            <Image image={content?.image} base="original" size="contain" position="left" />
          </div>
        ) : (
          content?.label && (
            <MuiTypography variant="h6" data-testid="qa-small-cta-component-label">
              {content.label}
            </MuiTypography>
          )
        )}
      </div>
      <ChevronRight fontSize="small" className={classes.icon} />
    </WithLink>
  );
};

export const ColumSmallCTA = ({
  theme = Theme.light,
  content = [],
}: Partial<SquareTileColumnContent>) => {
  const numOfCTAs = content.length;
  const classes = useStyles({ numOfCTAs });

  return (
    <div data-testid="qa-column-small-cta" className={classes.column}>
      {content.map((item, id) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={id} className={classes.item}>
          <SmallCTA theme={theme} content={item} />
        </div>
      ))}
    </div>
  );
};

export default SmallCTA;
